/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaMenumateConsumptionReportCtrl
 * @description
 */
angular.module('mercury.modules.qa.menumate.consumptionreport')
.controller('QaMenumateConsumptionReportCtrl', ["$filter", "$http", "reporttime", "$scope", "title", "settings", function($filter, $http, reporttime, $scope, title, settings) {
  title.set('Consumption Report');

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaMenumateConsumption', {
    params: {startTime: reporttime.start(), endTime: reporttime.end()}});
  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);
    $scope.allLines = response.data.lines;

    var categoryGroups = $filter('groupby')(response.data.lines, 'groupName');

    $scope.results = [];
    angular.forEach(categoryGroups, function(categoryGroup) {
      $scope.results.push({
        name: categoryGroup[0].groupName,
        lines: categoryGroup,
        courses: $filter('groupby')(categoryGroup, 'courseName')
      });
    });

  });
}]);
